import React from 'react';
import { NotesTab } from '@/components/common/NotesTab';

/**
 * AgentDocumentsTab — thin wrapper around the shared NotesTab component for
 * agent-scoped internal notes. Split into its own file so future document
 * management (attachments, licenses, contracts) can live alongside without
 * touching the orchestrator.
 */
export const AgentDocumentsTab = ({ npn }) => (
  <div data-testid="agent-documents-tab">
    <NotesTab entityType="agent" entityId={npn} />
  </div>
);

export default AgentDocumentsTab;
